import React, { useEffect, useState } from 'react';
import {
  AssetGroup,
  AssetGroupItem,
  UnrealisedGainsLossesGroup,
  PortfolioDetailResult,
  PortfolioParameters,
  SecurityColumnVisibility,
} from '../store/types';
import { SecurityListTable } from './SecurityListTable';

export interface Props {
  clientId: number | null;
  parameters: PortfolioParameters;
  portfolioAssetGroups: AssetGroup[];
  gainsLossesItems: UnrealisedGainsLossesGroup[];
  portfolioDetailResult?: PortfolioDetailResult;
  totalValue: number;
  progress: { hasErrors: boolean; isLoading: boolean };
  columnVisibility: SecurityColumnVisibility;
  setParameters: (parameters: PortfolioParameters) => void;
  setColumnVisibility: (visibility: SecurityColumnVisibility) => void;
}

export const PortfolioDetails = (props: Props): JSX.Element => {
  const { portfolioAssetGroups, parameters, progress, portfolioDetailResult } = props;

  const [selectedAssetGroup, setSelectedAssetGroup] = useState<AssetGroup | null>(null);
  const [selectedSecurity, setSlectedSecurity] = useState<AssetGroupItem | null>(null);

  useEffect(() => {
    setSelectedAssetGroup(portfolioAssetGroups.length > 0 ? portfolioAssetGroups[0] : null);
  }, [portfolioAssetGroups]);

  let filteredAssetGroupItems = selectedAssetGroup?.items;

  useEffect(() => {
    const currentSecurityId = selectedSecurity?.securityId;
    if (portfolioAssetGroups.length > 0 && progress.isLoading === false) {
      const defaultGroup = portfolioAssetGroups[0];
      setSelectedAssetGroup(defaultGroup);

      const allItems = portfolioAssetGroups.flatMap((group) => group.items);
      const match = currentSecurityId ? allItems.find((x) => x.securityId === currentSecurityId) : null;

      setSlectedSecurity(match ?? null);
    }
  }, [portfolioAssetGroups, progress]);

  if (!parameters.showPositionsNotHeld) {
    filteredAssetGroupItems = selectedAssetGroup?.items.filter((i) => i.units !== 0);
  }

  if (!filteredAssetGroupItems?.length) {
    if (portfolioAssetGroups.length == 2) {
      filteredAssetGroupItems = portfolioAssetGroups[1]?.items;
    }
  }

  return (
    <SecurityListTable
      data={filteredAssetGroupItems ?? []}
      columnVisibility={props.columnVisibility}
      setColumnVisibility={props.setColumnVisibility}
      setParameters={props.setParameters}
      progress={progress}
      parameters={parameters}
      portfolioDetailResult={portfolioDetailResult}
      assetClassTitle={!selectedAssetGroup ? parameters.groupingType : selectedAssetGroup.groupName}
      selectedAssetGroup={selectedAssetGroup}
    />
  );
};
